export const ForgotPasswordNC = {
	methods: {
		postForgotPassword(response) {
			if (response.status == 204) {
				this.$router.push({
					path: `/login`
				}).catch(()=>{});
				this.$notify.success({
					title: "Success",
					message: "Success"
				});
			}
		}
	}
};
